import axios from "axios";
import { BaseApi } from "./config";

const Axios = axios.create({ baseURL: BaseApi });

Axios.interceptors.request.use(
  (AxiosConfig) => {
    const newConfig = { ...AxiosConfig };
    newConfig.withCredentials = true;
    const isFormData = newConfig.data instanceof FormData;
    if (!isFormData && !newConfig.headers["Content-Type"]) {
      newConfig.headers["Content-Type"] = "application/json";
    }
    if (isFormData) {
      delete newConfig.headers["Content-Type"];
    }
    return newConfig;
  },
  (error) => {
    Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("liResponse");
      alert("نشست شما منقضی شده است، دوباره وارد شوید.");
      window.open(`/login`, "_self");
    }
    return Promise.reject(error);
  }
);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  GET: Axios.get,
  POST: Axios.post,
  PUT: Axios.put,
  PATCH: Axios.patch,
  DELETE: Axios.delete,
};